import { Navigation } from 'zudoku';

const productsItems: Navigation = [
    {
        type: 'link',
        icon: 'codesandbox',
        label: 'Beyond Sandbox',
        to: 'products/beyond-sandbox'
    },
    {
        type: 'link',
        icon: 'clipboard-list',
        label: 'Beyond Compliance',
        to: 'products/beyond-compliance'
    },
    {
        type: 'link',
        icon: 'banknote',
        label: 'Beyond Cash',
        to: 'products/beyond-cash',
        badge: {
            color: 'yellow',
            label: 'Soon'
        }
    },
    {
        type: 'link',
        icon: 'scale',
        label: 'Tax Compliance Gateway',
        to: 'products/tax-collection-gateway/api-reference'
    }
];

export const sidebar: Navigation = [
    {
        type: 'doc',
        label: 'Quickstart',
        icon: 'circle-play',
        file: 'quickstart'
    },
    {
        type: 'category',
        label: 'Products',
        items: productsItems,
        collapsible: false
    },
    {
        type: 'doc',
        label: 'API Status',
        icon: 'activity',
        file: 'api-status',
        display: 'hide'
    },
    {
        type: 'doc',
        label: 'Support',
        icon: 'circle-question-mark',
        file: 'support'
    }
]
